import React, { useState } from "react";
import AccountAddress from "../../../components/AccountAddress";
import LibraAmount from "../../../components/LibraAmount";

const PaymentsTable = ({ payments }) => {
  const [sortConfig, setSortConfig] = useState({
    key: "deadline",
    direction: "descending",
    previousKey: "address",
  });

  const sortedPayments = React.useMemo(() => {
    let sortablePayments = payments ? [...payments] : [];
    sortablePayments.sort((a, b) => {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];

      if (aValue < bValue) return sortConfig.direction === "ascending" ? -1 : 1;
      if (aValue > bValue) return sortConfig.direction === "ascending" ? 1 : -1;

      // Tiebreaker using the previousKey
      const aPreviousValue = a[sortConfig.previousKey];
      const bPreviousValue = b[sortConfig.previousKey];

      if (aPreviousValue < bPreviousValue) return -1;
      if (aPreviousValue > bPreviousValue) return 1;

      // Final tiebreaker using amount
      if (a.amount < b.amount) return 1;
      if (a.amount > b.amount) return -1;

      return 0;
    });
    return sortablePayments;
  }, [payments, sortConfig]);

  const requestSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction, previousKey: sortConfig.key });
  };

  if (payments?.length === 0) {
    return <p>No payments found at the moment.</p>;
  }

  return (
    <div className="overflow-x-auto relative">
      <table className="w-full text-sm text-left text-gray-600">
        <thead className="text-xs uppercase bg-gray-50">
          <tr>
            <th
              className="py-2 px-4 cursor-pointer whitespace-nowrap"
              onClick={() => requestSort("address")}
            >
              CW Address{" "}
              {sortConfig.key === "address"
                ? sortConfig.direction === "ascending"
                  ? "↑"
                  : "↓"
                : ""}
            </th>
            <th
              className="py-2 px-4 cursor-pointer whitespace-nowrap"
              onClick={() => requestSort("name")}
            >
              Name{" "}
              {sortConfig.key === "name"
                ? sortConfig.direction === "ascending"
                  ? "↑"
                  : "↓"
                : ""}
            </th>
            <th
              className="py-2 px-4 cursor-pointer whitespace-nowrap"
              onClick={() => requestSort("deadline")}
            >
              Deadline{" "}
              {sortConfig.key === "deadline"
                ? sortConfig.direction === "ascending"
                  ? "↑"
                  : "↓"
                : ""}
            </th>
            <th
              className="py-2 px-4 cursor-pointer whitespace-nowrap"
              onClick={() => requestSort("payee")}
            >
              Payee{" "}
              {sortConfig.key === "payee"
                ? sortConfig.direction === "ascending"
                  ? "↑"
                  : "↓"
                : ""}
            </th>
            <th
              className="py-2 px-4 cursor-pointer whitespace-nowrap"
              onClick={() => requestSort("description")}
            >
              Description{" "}
              {sortConfig.key === "description"
                ? sortConfig.direction === "ascending"
                  ? "↑"
                  : "↓"
                : ""}
            </th>
            <th
              className="py-2 px-4 cursor-pointer whitespace-nowrap"
              onClick={() => requestSort("amount")}
            >
              Amount{" "}
              {sortConfig.key === "amount"
                ? sortConfig.direction === "ascending"
                  ? "↑"
                  : "↓"
                : ""}
            </th>
          </tr>
        </thead>
        <tbody>
          {sortedPayments.map((payment, index) => (
            <tr
              key={index}
              className={`border-b ${
                (index + 1) % 2 === 0 ? "bg-gray-50" : "bg-white"
              }`}
            >
              <td className="py-2 px-4">
                <AccountAddress address={payment.address} />
              </td>
              <td className="py-2 px-4">{payment.name}</td>
              <td className="py-2 px-4">{payment.deadline}</td>
              <td className="py-2 px-4">
                <AccountAddress address={payment.payee} />
              </td>
              <td className="py-2 px-4">{payment.description}</td>
              <td className="py-2 px-4">
                <LibraAmount amount={payment.amount} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PaymentsTable;
